import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'

import {getSizingInfoByProductCategory} from '../../../utils'
import * as pdp from '../../../store/productDetailPage'
import * as track from '../../../track/product'
import * as URLS from '../../../urls'

const categoriesToShowFitFinderText = ['suits', 'tuxedos', 'shirts', 'shoes', 'vests']

export const ProductSidebarSizing = ({productCategorySlug}) => (
  <Fragment>
    <ul className="c-product-sidebar__list">
      {getSizingInfoByProductCategory(productCategorySlug).map((bulletPoint) => (
        <li key={bulletPoint}>{bulletPoint}</li>
      ))}
    </ul>
    {categoriesToShowFitFinderText.includes(productCategorySlug) && (
      <p>
        Our{' '}
        <Link to={URLS.FIT_LP} onClick={() => track.pdpClicked('Sizing Fit Finder', URLS.FIT_LP)}>
          Fit Finder
        </Link>{' '}
        quiz will help you find the right sizes before checkout.
      </p>
    )}
  </Fragment>
)

ProductSidebarSizing.propTypes = {
  productCategorySlug: PropTypes.string.isRequired,
}

const mapStateToProps = createStructuredSelector({
  productCategorySlug: pdp.productCategorySlug,
})

export default connect(mapStateToProps)(ProductSidebarSizing)
